import React, {Component, PureComponent} from "react";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ModalHelper, AlertModal, helper}  from "./../app.js"; 

export default class AccCoverSelecter extends PureComponent 
{
    prevAccQuantity = 0;
    //real_quantity = 0;
    modal = null;

    constructor (props)
    {
        super(props);

        const hasCover = !helper.isNotObjectOrEmpty(this.props.init_cover);

        this.state = {
            covers: {},
            id: hasCover ? this.props.init_cover.id : '', 
            quantity: 0,
            loading: false,
            alert_message: '' 
        };        
        this.state.quantity = this.prevAccQuantity = hasCover ? this.props.init_cover.quantity : this.props.acc_quantity;

        this.modal = new ModalHelper(this);

        this.isActive = this.isActive.bind(this);
        this.markNeedCover = this.markNeedCover.bind(this);
        this.setQuantity = this.setQuantity.bind(this);
        //this.roundQuantity = this.roundQuantity.bind(this);
        this.quantityFromAccIfZero = this.quantityFromAccIfZero.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    get cover ()
    {
        const id = this.state.id;
        let cover = null;

        if (id && id in this.state.covers)
        {
            cover = this.state.covers[id];
        }
        return cover;
    }
    isActive ()
    {
        return this.props.acc_cover_id && this.props.acc_quantity;
    }
    loadCovers ()
    {
        if (this.props.acc_cover_id)
        {   
            const queryParams = {acc_cover_id: this.props.acc_cover_id};

            this.setState({loading: true});

            Server.instance
                .query('get_accessory_covers', queryParams)
                .then((recievedCovers) =>
                {
                    helper.setStateWithRecievedItems(this, 'covers', recievedCovers);
                })
                .catch(() => this.setState({covers: {}, loading: false}));
        }
    }
    markNeedCover (e)
    {
        let id = '', 
            cover;
        const needCover = e.target.checked;

        //console.log(needCover, this.state.covers);
        
        if (!needCover)
        {
            this.props.on_select(null);
        }
        else if (!helper.isNotObjectOrEmpty(this.state.covers))
        {
            id = Object.keys(this.state.covers).shift();

            if (this.state.quantity)
            {
                cover = helper.copyObject(this.state.covers[id]);
                cover.quantity = this.state.quantity;

                this.props.on_select(cover);
            }
        }

        this.setState({id});    
    }
    setQuantity (e)
    {
        const cover = helper.copyObject(this.cover);

        if (!helper.isNotObjectOrEmpty(cover))
        {
            let quantity = e.target.value;
            
            if ('' !== quantity)
            {
                quantity = parseInt(quantity);

                if (isNaN(quantity) || quantity < 0)
                {
                    this.setState({alert_message: 'Некорректное значение количества крышек для аксессуара'});
                }
                else if (!quantity)
                {
                    this.setState({alert_message: 'Не задано количество крышек для аксессуара'});
                }
                else if (quantity > this.props.acc_quantity)
                {
                    this.setState({alert_message: 'Количество крышек не может быть больше чем задано для аксессуара'});
                }
                else 
                {
                    this.setState({quantity});

                    cover.quantity = quantity;
                    this.props.on_select(cover);
                }
            }
            else
                this.setState({quantity});
        }
    }/*
    roundQuantity ()
    {
        const cover = this.cover,
            hasCover = !helper.isNotObjectOrEmpty(cover),
            quantityMultiple = hasCover ? parseInt(this.props.quantity_multiple) : false;

        if (quantityMultiple && this.real_quantity)
        {
            const quantity = this.real_quantity/quantityMultiple;

            this.setState({quantity});  
        }
    }*/
    quantityFromAccIfZero ()
    {
        if (!this.state.quantity)
        {
            this.setState({quantity: this.prevAccQuantity});
        }
    }
    componentDidMount () 
    {
        this.loadCovers();
    }
    componentDidUpdate () 
    {
        if (this.props.acc_quantity !== this.prevAccQuantity) 
        {
            const cover = helper.copyObject(this.cover),
                quantity = this.props.acc_quantity;

            this.prevAccQuantity = quantity;
            this.setState({quantity});            

            if (!helper.isNotObjectOrEmpty(cover) && this.isActive())
            {
                cover.quantity = quantity;                
                this.props.on_select(cover);
            } 
        }
    }
    render () 
    {
        const cover = this.cover,
            hasCovers = !helper.isNotObjectOrEmpty(this.state.covers), 
            hasCover = !helper.isNotObjectOrEmpty(cover),
            quantity = this.state.quantity ? this.state.quantity : '';

        return  <><Form.Group>
                    <Form.Check onChange={this.markNeedCover} checked={hasCover} disabled={!(hasCovers && this.isActive())} type="switch" id="acc_need_cover_switch" label="Нужна крышка" /> 
                    {this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}
                    <div className={!(hasCover && this.isActive()) ? 'd-none' : ''}>
                        <Form.Label muted={!this.isActive()}>Количество крышек,&nbsp;шт</Form.Label>
                        <Form.Control onChange={this.setQuantity} onBlur={this.quantityFromAccIfZero} onClick={this.modal.showProjectChangeWarning} value={quantity} disabled={!(hasCover && this.isActive())} type="text" placeholder="Количество крышек, шт" />
                    </div>
                </Form.Group>
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
        //  onBlur={this.roundQuantity}
    }    
}